import { useEffect } from "react";

import clinic from "../config/clinic.json";

const SITE = (process.env.REACT_APP_SITE_URL || clinic.siteUrl || "").replace(/\/$/, "");

export function LocalBusinessJsonLd() {
  useEffect(() => {
    const id = "pontepie-localbusiness-jsonld";
    const existing = document.getElementById(id);
    const data: Record<string, unknown> = {
      "@context": "https://schema.org",
      "@type": "Podiatrist",
      name: "PontePie",
      alternateName: "Podólogo en Pontedeume",
      description: "Podólogo en Pontedeume — clínica podológica PontePie con Cristina Vila Portela",
      address: {
        "@type": "PostalAddress",
        streetAddress: clinic.street,
        postalCode: clinic.postalCode,
        addressLocality: clinic.city,
        addressRegion: clinic.province,
        addressCountry: "ES",
      },
      telephone: clinic.phoneE164,
      email: clinic.contactEmail,
      sameAs: [clinic.instagram, clinic.facebook],
      openingHoursSpecification: [
        {
          "@type": "OpeningHoursSpecification",
          dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday"],
          opens: "10:00",
          closes: "14:00",
        },
        {
          "@type": "OpeningHoursSpecification",
          dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday"],
          opens: "16:00",
          closes: "20:00",
        },
        {
          "@type": "OpeningHoursSpecification",
          dayOfWeek: "Friday",
          opens: "10:00",
          closes: "15:00",
        },
      ],
    };
    if (SITE) data.url = SITE;

    const script = (existing || document.createElement("script")) as HTMLScriptElement;
    script.id = id;
    script.type = "application/ld+json";
    script.textContent = JSON.stringify(data);
    if (!existing) document.head.appendChild(script);
    return () => {
      document.getElementById(id)?.remove();
    };
  }, []);
  return null;
}
